import Vue from 'vue'
import VueOffline from 'vue-offline'

Vue.use(VueOffline, {
  storage: false,
  mixin: false
})
